var e={REVERSE_GEOCODE:"/api/location/reverse-geocode?latitude=#{latitude}&longitude=#{longitude}"};export{e as COMMON_API_URLS};
//# sourceMappingURL=apis.js.map
